/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
          // JavaScript to be fired on all pages, after page specific JS is fired

          $('.scroll-to-top').on('click', function(){

              $('html,body').animate({

                  scrollTop: $('body').offset().top

              }, 'slow');



          });

          if ( $( '.circle-overlay-flag-container' ).length )

          {

              var image_size;

              var position;

              var image_counter = 0;

              $('.circle-overlay-flag-container img').each(function(){

                  image_size = $(this).height();

                  position = parseInt(image_size ) - 20;

                  $(this).css('right', image_counter*position);

                  image_counter++;

              });



              $( window ).resize(function() {

                  var image_size;

                  var position;

                  var image_counter = 0;

                  $('.circle-overlay-flag-container img').each(function(){

                      image_size = $(this).height();

                      position = parseInt(image_size ) - 20;

                      $(this).css('right', image_counter*position);

                      image_counter++;

                  });

              });

          }

          $('.become-my-student').on('click', function(){

              var speaker = $(this).attr('data-speaker');

              speaker = speaker.toUpperCase();

              var language = $(this).attr('data-language');

              language = language.toUpperCase();

              $('#message').val('Chciałbym skorzystać z bezpłatnej lekcji próbnej, język ' + language +  '. Proszę o kontakt.');

              $.ajax({

                  method: "GET",

                  url: ajax_url + '?speaker=' + speaker + '&language=' + language

              });

              $('html,body').animate({

                  scrollTop: $('#contact-form-section').offset().top - 100

              }, 'slow');



          });

          if(window.location.hash)

          {

              $('html,body').animate({

                  scrollTop: $(window.location.hash).offset().top - 100

              }, 'slow');

          }


      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
          // JavaScript to be fired on the home page, after the init JS


      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };
  //Init Materialize Components Below
  $( document ).ready(function(){
    $(".button-collapse").sideNav();
  });
  //Smooth scroll sections
  $(function() {
    $('a[href*=#]:not([href=#])').click(function() {
      if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {

        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html,body').animate({
            scrollTop: target.offset().top-80
          }, 1000);
          return false;
        }
      }
    });
      $(".nav-wrapper ul li a").each(function(){
          $(this).removeClass('active');
      });
      $('.homepage-link').addClass('active');

      $(".nav-wrapper ul li a").on('click', function(){
          $(".nav-wrapper ul li a").each(function(){
              $(this).removeClass('active');
          });
          $(this).addClass('active');
      });
      /*function onScroll(){
          var scrollPosition = $(document).scrollTop();
          if(scrollPosition === 0)
          {
              $('.nav-wrapper ul li a').each(function () {
                  var currentLink = $(this);
                  currentLink.parent().removeClass("active");
              });
              $('.homepage-link').addClass('active');
          }
          else
          {

              $('.nav-wrapper ul li a').each(function () {
                  var currentLink = $(this);
                  if(!currentLink.parent().hasClass('homepage-link'))
                  {
                      var refElement = $(currentLink.attr("href"));
                      if (refElement.position().top <= scrollPosition && refElement.position().top + refElement.height() > scrollPosition) {
                          $('.homepage-link').removeClass("active");
                          currentLink.parent().addClass("active");
                      }
                      else{
                          currentLink.parent().removeClass("active");
                          $('.homepage-link').addClass("active");
                      }
                  }
              });
          }
      }
      $(document).ready(function () {
          $(document).on("scroll", onScroll);
      });*/
  });

})(jQuery); // Fully reference jQuery after this point.
